module.exports = __webpack_public_path__ + "img/app.ee8223fe.png";